import { useTranslation } from 'react-i18next';
import Badge, { type BadgeVariant } from '@/components/base/Badge';
import type { SettlementStatus } from '@/types';

const VARIANTS: Record<SettlementStatus, BadgeVariant> = {
  processing: 'warning',
  transferred: 'success',
  rejected: 'danger',
};

const ICONS: Record<SettlementStatus, string> = {
  processing: 'ri-time-line',
  transferred: 'ri-checkbox-circle-line',
  rejected: 'ri-close-circle-line',
};

export default function SettlementStatusBadge({ status }: { status: SettlementStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={VARIANTS[status]} icon={ICONS[status]}>
      {t(`finance.status.${status}`)}
    </Badge>
  );
}